import Button from 'react-bootstrap/Button';

import { FISCAL_WEEKDAY_OPTIONS } from 'utils/fiscalPeriods';

import type { FiscalPeriodPatch } from './shared';

interface Props {
  readonly weekday: number;
  readonly startDay: string;
  readonly endDay: string;
  readonly patch: FiscalPeriodPatch;
}

/** Button group for the weekday every fiscal period starts on. */
export const WeekdayPicker = ({ weekday, startDay, endDay, patch }: Props) => (
  <>
    <h6 className="mb-2">Period start weekday</h6>
    <div className="d-flex flex-wrap gap-2 mb-2">
      {FISCAL_WEEKDAY_OPTIONS.map((weekdayOption) => (
        <Button
          key={weekdayOption.value}
          type="button"
          size="sm"
          className="fiscal-period-editor__weekday"
          variant={weekday === weekdayOption.value ? 'primary' : 'outline-secondary'}
          aria-pressed={weekday === weekdayOption.value}
          onClick={() => patch({ weekday: weekdayOption.value })}
        >
          {weekdayOption.label.slice(0, 3)}
        </Button>
      ))}
    </div>
    <p className="text-muted small mb-4">
      Periods start on <strong>{startDay}</strong>, so the year ends on <strong>{endDay}</strong>. All seven weekdays are used in the wild — Monday is common in
      Europe (ISO week), Sunday in US retail, Friday/Saturday where the weekend falls differently.
    </p>
  </>
);
